// import Security from '@/_helpers/security.js'

const old_layout = () => import('@/layout/old_layout.vue');
import profile from '@/routes_new/inner/profile';

// common
import RatesInformer from '@/routes_new/inner/settings/rates/RatesInformer';
import HeaderView from '@/components/header/Scene';

// const SettingsShop = () => import(/* webpackChunkName: "settings-shop" */ '@/process/sportmaster/components/settings/shop/SettingsShop')

export default [
  {
    path: '',
    component: old_layout,
    children: [
      {
        path: 'profile',
        // beforeEnter: Security.requireAuth,
        components: {
          default: profile,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        meta: {
          title: 'pageTitles.routes.profile.root'
        }
        // children: [
        //   {
        //     path: 'shop',
        //     component: SettingsShop,
        //     name: 'profile-shop',
        //     meta: {
        //       title: 'profileMenu.settingsShop.link'
        //     }
        //   }
        // ]
      }
    ]
  }
];
